export default __webpack_public_path__ + "static/media/aroma14.b2d1fcbc.png";